import { pushToFrame } from '@/components/signFeedback/utils/LandmarksMapper';

export async function prepare(videoEl: HTMLVideoElement): Promise<void> {
    try { videoEl.pause(); } catch {}
    try { videoEl.load(); } catch {}
    if (!isFinite(videoEl.duration) || videoEl.duration === 0) {
        await new Promise<void>(resolve => {
            const handler = () => resolve();
            videoEl.addEventListener('loadedmetadata', handler, { once: true });
            setTimeout(() => resolve(), 500);
        });
    }
}

export async function seekTo(videoEl: HTMLVideoElement, timeSec: number): Promise<void> {
    await new Promise<void>(resolve => {
        const handler = () => resolve();
        videoEl.addEventListener('seeked', handler, { once: true });
        try { videoEl.currentTime = timeSec; } catch (e) { resolve(); }
    });
}

export async function singleFrameCollect(
    videoEl: HTMLVideoElement,
    timesSec: number[],
    holistic: any,
    onResultsToRestore: (results: any) => void,
    onProgress?: (processed: number, total: number) => void,
    shouldCancel?: () => boolean,
): Promise<{ bitmaps: HTMLCanvasElement[], landmarks: number[][] }> {
    const holisticAny: any = holistic;
    const frames: number[][] = [];
    const bitmaps: HTMLCanvasElement[] = [];
    const collectOnce = (results: any) => {
        const frame: number[] = [];
        pushToFrame(frame, results.poseLandmarks, 33);
        pushToFrame(frame, results.leftHandLandmarks, 21);
        pushToFrame(frame, results.rightHandLandmarks, 21);
        pushToFrame(frame, results.faceLandmarks, 468);
        frames.push(frame);
    };
    if (holisticAny && typeof holisticAny.onResults === 'function') {
        holisticAny.onResults(collectOnce);
    }
    const restore = () => {
        if (holisticAny && typeof holisticAny.onResults === 'function') {
            holisticAny.onResults(onResultsToRestore);
        }
        try { videoEl.pause(); } catch {}
    };
    await prepare(videoEl);
    for (let i = 0; i < timesSec.length; i++) {
        if (shouldCancel && shouldCancel()) { restore(); return { bitmaps, landmarks: frames }; }
        const t = timesSec[i];
        await seekTo(videoEl, t);
        const off = document.createElement('canvas');
        off.width = videoEl.videoWidth || 640;
        off.height = videoEl.videoHeight || 480;
        const offCtx = off.getContext('2d')!;
        try { offCtx.drawImage(videoEl, 0, 0, off.width, off.height); } catch {}
        bitmaps.push(off);
        if (holistic) {
            try { await holistic.send({ image: videoEl }); } catch {
                restore();
                return { bitmaps, landmarks: frames };
            }
        }
        if (onProgress) onProgress(i + 1, timesSec.length);
    }
    restore();
    return { bitmaps, landmarks: frames };
}


